import { Link } from "@tanstack/react-router";
import { AppIcon, Button } from "@wilco/ui";
import { t } from "../i18n.ts";
import { formatMonth, monthOf } from "./api.ts";

/** Шапка раздела себестоимости: три экрана одной вкладкой ссылок. */
export function CostingHead({ title }: { title: string }) {
  return (
    <>
      <div className="page-head">
        <h1 className="page-title page-title-icon">
          <AppIcon name="dashboards" size={32} />
          {title}
        </h1>
      </div>
      <nav className="costing-nav" aria-label={t("costing.nav")}>
        <Link to="/costing/close" activeProps={{ "aria-current": "page" }}>
          {t("costing.close.title")}
        </Link>
        <Link to="/costing/pnl" activeProps={{ "aria-current": "page" }}>
          {t("costing.pnl.title")}
        </Link>
        <Link to="/costing/prices" activeProps={{ "aria-current": "page" }}>
          {t("costing.prices.title")}
        </Link>
      </nav>
    </>
  );
}

/** Месяц стрелками: назад и вперёд на один, подпись словами. */
export function MonthPicker({ month, onChange }: { month: string; onChange: (m: string) => void }) {
  const shift = (n: number) => monthOf(n, new Date(`${month}-15T00:00:00Z`));
  return (
    <div className="month-picker" role="group" aria-label={t("costing.month")}>
      <Button variant="ghost" onClick={() => onChange(shift(-1))} aria-label={t("costing.prevMonth")}>
        ‹
      </Button>
      <span className="month-picker-label">{formatMonth(month)}</span>
      <Button variant="ghost" onClick={() => onChange(shift(1))} aria-label={t("costing.nextMonth")}>
        ›
      </Button>
    </div>
  );
}
